import TranslateIcon from '@mui/icons-material/Translate';
import { Badge, IconButton } from '@mui/material';
import { useState } from 'react';
import { TranslatedText } from '../../interfaces/Translation';
import { TranslatedTextDialog } from './TranslatedTextDialog';
import { RichTextEditorProps } from '../RichTextEditor/RichTextEditor';

type TranslationAdornmentProps = {
  defaultValue: string;
  value: TranslatedText;
  onChange: (newValue: TranslatedText) => void;
  multiline?: boolean;
  richText?: boolean;
  richTextProps?: Partial<RichTextEditorProps>;
};

export const TranslationAdornment = ({
  defaultValue,
  value,
  onChange,
  multiline,
  richText,
  richTextProps,
}: TranslationAdornmentProps) => {
  const [showDialog, setShowDialog] = useState(false);

  const validTranslationCount = Object.values(value).filter((x) => x).length;

  return (
    <>
      <TranslatedTextDialog
        defaultValue={defaultValue}
        value={value}
        multiline={multiline}
        richText={richText}
        open={showDialog}
        onClose={() => setShowDialog(false)}
        onTranslate={(x) => {
          onChange(x);
          setShowDialog(false);
        }}
        richTextProps={richTextProps}
        width={richText ? 900 : 450}
      />

      <IconButton color='primary' onClick={() => setShowDialog(true)}>
        {validTranslationCount > 0 && (
          <Badge
            color='primary'
            badgeContent={validTranslationCount}
            overlap='circular'
            style={{ transform: 'translate(25px, -12px)' }}
          />
        )}

        <TranslateIcon />
      </IconButton>
    </>
  );
};
